import api from 'api'

export type CreateVndlyCandidateParams = {
  workerId: number
  vndlyInstanceId: number
}

export type CreateVndlyCandidateResponse = {
  candidateId: number
}

export const createVndlyCandidate = async (
  params: CreateVndlyCandidateParams
): Promise<CreateVndlyCandidateResponse> => {
  const result = await api.post<CreateVndlyCandidateResponse>(
    '/admin/vndly/candidates/create',
    params
  )
  return result.data
}
